"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _Typography = _interopRequireDefault(require("@mui/material/Typography/Typography.js"));
var _Tooltip = _interopRequireDefault(require("@mui/material/Tooltip"));
var _InfoOutlined = _interopRequireDefault(require("@mui/icons-material/esm/InfoOutlined.js"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const InfoTip = ({
  title,
  sx = {}
}) => {
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_Tooltip.default, {
    title: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Typography.default, {
      children: title
    }),
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_InfoOutlined.default, {
      sx: {
        mx: .5,
        ...sx
      },
      fontSize: "small"
    })
  });
};
var _default = exports.default = InfoTip;